import React from 'react';
import { ANNOTATION_SHAPE_STYLING_TYPE } from '../../../../constants';
import type { RectDataT, SkeletonPreviewStyleT } from '../../../../types';
import { getStylesForStylingType } from '../../utils';
import { SKELETON_PREVIEW_STYLE } from '../constants';
type PropsT = {
  box: RectDataT;
  style: SkeletonPreviewStyleT;
};
export const PreviewBoundingBox = ({
  box,
  style
}: PropsT) => <rect x={box.x} y={box.y} width={box.width} height={box.height} stroke={style.strokeColor} fill={style.strokeColor} fillOpacity={SKELETON_PREVIEW_STYLE.BOX_FILL_OPACITY} style={{
  strokeWidth: style.strokeWidth
}} {...getStylesForStylingType(ANNOTATION_SHAPE_STYLING_TYPE.DASHED_BORDER)} />;